import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const SearchTerms = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_SEARCHTERMS_STATISTICS] : (_,action)=>action.status
})

export default SearchTerms
